import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import { COMPANION_APP_URL } from '../lib/companionNudge';

/** Fraction of eligible success modals that surface the Companion promo (0–1). */
const COMPANION_NUDGE_CHANCE = 0.5;

const COPY = {
  'appointment-created': {
    title: 'Your appointment was created successfully',
    lead: 'Your booking has been saved on ClinicPlus.',
    approval:
      'An administrator will review your appointment next. You will be able to proceed with payment and final steps once it has been approved.',
    continueLabel: 'Continue to appointment',
    showCompanion: true,
  },
  'appointment-edited': {
    title: 'Your appointment was updated successfully',
    lead: 'Your changes have been saved on ClinicPlus.',
    approval:
      'An administrator will review your appointment next. You will be able to proceed with payment and final steps once it has been approved.',
    continueLabel: 'Continue to appointment',
    showCompanion: false,
  },
  'company-created': {
    title: 'Your company was created successfully',
    lead: 'Your company has been saved on ClinicPlus.',
    approval: null,
    continueLabel: 'Continue to company',
    showCompanion: true,
  },
};

function AppointmentSuccessModal({ show, variant = 'appointment-created', onClose }) {
  const copy = COPY[variant] || COPY['appointment-created'];
  const [showCompanionNudge, setShowCompanionNudge] = useState(false);

  useEffect(() => {
    if (show && copy.showCompanion) {
      setShowCompanionNudge(Math.random() < COMPANION_NUDGE_CHANCE);
    } else {
      setShowCompanionNudge(false);
    }
  }, [show, copy.showCompanion]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{copy.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">{copy.lead}</p>
        {copy.approval && <p className="mb-3">{copy.approval}</p>}
        <p className="mb-3">
          Have feedback or an idea to improve bookings?{' '}
          <Link to="/feedback" onClick={onClose}>
            Suggest a new feature
          </Link>{' '}
          from the sidebar — we read every submission.
        </p>
        {showCompanionNudge && (
          <>
            <p className="mb-0">
              For repeat bookings, try{' '}
              <strong>ClinicPlus Bookings Companion</strong> — create and manage employee rosters,
              store repeat employees for appointments, check clinic availability, and track team
              compliance.
            </p>
            <a
              href={COMPANION_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-danger mt-3"
            >
              Open ClinicPlus Bookings Companion
            </a>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {copy.continueLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AppointmentSuccessModal;
